export default __webpack_public_path__ + "static/salsa-home-2a7826b534899752cd40c3b2b2ae7789.jpg";